export default __webpack_public_path__ + "static/media/V880_CoC.91768365.pdf";